<template>
<div class="animated fadeIn">
  <form enctype="multipart/form-data" v-on:submit="submit($event,false)">
    <div class="row">
      <div class="col-md-8">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-fieldset label="Valor Aberto">
            <b-form-input type="text" name="open" v-model="item.open" placeholder="Valor Aberto"></b-form-input>
          </b-form-fieldset>
          <b-form-fieldset label="Valor Expirado">
            <b-form-input type="text" name="expired" v-model="item.expired" placeholder="Valor Aberto"></b-form-input>
          </b-form-fieldset>
          
          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'users.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!--/.col-->
    </div>
  </form>
</div>
</template>

<script>
export default {
  name: 'SettingsEdit',
  props: ['id'],
  data() {
    return {
      item: {
        open: 0,
        expired: 0
      },
      roles: []
    }
  },
  methods: {
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      this.axios.put('settings', data)
        .then(response => {
          this.item = response.data.data
          this.$toastr('success', 'item gravado com sucesso', 'Gravado')
        })
        .catch(response => {
          this.$toastr('error', 'Não foi possivel gravar', 'Erro')
        })
    }
  },
  created() {
    this.axios.get('settings')
      .then(response => {
        this.item = response.data.data
      })
      .catch(response => {
        this.$toastr('error', 'Erro ao carregar definições', 'Erro')
        this.$router.push({
          name: 'settings.index'
        })
      })
  }
}
</script>



// WEBPACK FOOTER //
// SettingsEdit.vue?091ce6c0